// Import dependencies
import React from 'react';

// Import components
import LogoutButton from '../logout';


class AdminNavbar extends React.Component {
    render() {
        return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                <div className="navbar-nav">
                    <a className="nav-item nav-link" href="/admin/history">Login history</a>
                    <a className="nav-item nav-link" href="/admin/members">Members</a>
                    <a className="nav-item nav-link" href="/videos">Videos</a>
                    <a className="nav-item nav-link" href="/admin/affiliate">Affiliate Management</a>
                    <a className="nav-item nav-link" href="/admin/special">Special Access</a>
                    <div class="dropdown" >
                        <a class="nav-item nav-link" href="#" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Analytics &#x25BF;
                        </a>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <a class="dropdown-item" href="/admin/analytics/videos">Videos</a>
                            <a class="dropdown-item" href="/admin/analytics/livestream">Livestream</a>
                        </div>
                    </div>
                    <a className="nav-item nav-link" href="/admin/settings">Settings</a>
                </div>
            </div>
            <LogoutButton />
        </nav>
        
        )
    }
}

export default AdminNavbar;